// extracted by mini-css-extract-plugin
export default {"button":"logout_button__VyIJ0","border":"logout_border__t5pBi"};